export default __webpack_public_path__ + "static/media/i117sk.692464c4.webp";